<template>
    <!-- <div>
        wait admin approve your account
    </div> -->
    <q-layout view="hHh lpR fFf" style="display: grid">
        <q-page-container :style="$q.screen.width < 485 ? `` : `margin: auto`">
            <q-card
                flat
                bordered
                :class="$q.screen.width < 485 ? `my-card-mobile` : `my-card`"
            >
                <q-card-section>
                    <div class="row justify-center">
                        <q-img
                            basic
                            v-if="$q.screen.width < 485"
                            contain
                            width="50px"
                            :src="require('@/assets/logo-villa-mobile.svg')"
                        />
                        <q-img
                            basic
                            v-else
                            contain
                            width="100px"
                            :src="require('@/assets/logo-villa-mobile.svg')"
                        />
                    </div>
                    <div class="row justify-center">
                        <div class="text-h6">Villa market</div>
                    </div>
                </q-card-section>

                <q-card-section>
                    <div class="row justify-center">
                        <div class="text-h6">
                            Wait admin approve your account
                        </div>
                    </div>
                    <div class="row justify-center">
                        <div class="text-subtitle2">
                            if admin already has approved your account, try sign
                            out and sign in again.
                        </div>
                    </div>
                </q-card-section>
                <q-card-section>
                    <div class="row justify-center">
                        <q-btn
                            unelevated
                            class="full-width"
                            block
                            color="primary"
                            no-caps
                            no-wrap
                            label="Sign out"
                            @click="onSignOut"
                        />
                    </div>
                </q-card-section>
            </q-card>
        </q-page-container>
    </q-layout>
</template>

<script>
import useAuth from "@/mixins/useAuth";
import Auth from "@aws-amplify/auth";
export default {
    name: "WaitApprove",
    mixins: [useAuth],
    data() {
        return {
            interval: null,
        };
    },
    mounted() {
        this.interval = setInterval(this.update, 10000);
    },
    methods: {
        async update() {
            const user = await Auth.currentAuthenticatedUser({
                bypassCache: true,
            });

            const session = await Auth.currentSession();
            const groups = session.getIdToken().payload["cognito:groups"];
            console.log({ user });
            console.log({ groups });
            if (groups) {
                if (groups.includes("Sale") || groups.includes("Clickzy")) {
                    // clear interval
                    clearInterval(this.interval);
                    this.$router.replace({
                        name: "Home",
                    });
                }
            }
        },
    },
};
</script>
